export class Project{
    id: string;
    key?: string;
    name: string;
    description: string;
    category: string;
    status: number;
    created_at: any;
    platform: number;
    url: UrlModel;
    deadline: number;
    version: string;
    social: Social;
    is_released: boolean;
    credentials: {[key: string]: Credential}
}

export class UrlModel{
    production: string;
    staging: string;
    dev: string;
}

export class Social{
    [key: string]: string;
}

export class Credential{
    link: string;
    username: string;
    password: string;
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/model/projects.model.ts